import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ShareData {
  private noInternet = new BehaviorSubject<boolean>(false);
  currentNoInternet = this.noInternet.asObservable();

  private notificationCount = new BehaviorSubject<string>('0');
  currentNotificationCount = this.notificationCount.asObservable();

  private conversationCount = new BehaviorSubject<string>('0');
  currentConversationCount = this.conversationCount.asObservable();

  private likeFeedID = new BehaviorSubject<string>('0');
  currentLikeFeedID = this.likeFeedID.asObservable();

  private reactionType = new BehaviorSubject<string>('0');
  currentReactionType = this.reactionType.asObservable();

  private userDetails = new BehaviorSubject<any>('');
  currentUserDetails = this.userDetails.asObservable();

  private feedList = new BehaviorSubject<any>([]);
  currentFeedData = this.feedList.asObservable();

  private groudID = new BehaviorSubject<string>('');
  currentGroupID = this.groudID.asObservable();

  constructor() {}

  desktop() {
    return false;
  }

  changeNotificationCount(count: string) {
    this.notificationCount.next(count);
  }

  changeConversationCount(count: string) {
    this.conversationCount.next(count);
  }

  changeLikeFeedID(feedID: string) {
    this.likeFeedID.next(feedID);
  }

  changeReactionType(reactionType: string) {
    this.reactionType.next(reactionType);
  }

  setUserDetails(userDetails: any) {
    this.userDetails.next(userDetails);
  }

  changeFeedData(feedList: any) {
    this.feedList.next(feedList);
  }

  changeNoInternetStatus(status: boolean) {
    this.noInternet.next(status);
  }

  changeGroupID(id: string) {
    this.groudID.next(id);
  }
}



// WEBPACK FOOTER //
// ./src/providers/share-data/share-data.ts